import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import SharedView from "@/pages/SharedView";
import Pricing from "@/pages/Pricing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Landing from "@/pages/Landing";
import SharedDashboard from "@/pages/SharedDashboard";
import Demo from "@/pages/Demo";

function Loader({ label }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background text-muted-foreground">
      <div className="animate-pulse font-mono text-sm">{label}</div>
    </div>
  );
}

function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <Loader label="Loading command center…" />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function SubscribedRoute({ children }) {
  const { user, ready, subscription } = useAuth();
  if (!ready) return <Loader label="Loading command center…" />;
  if (!user) return <Navigate to="/login" replace />;
  if (subscription == null) return <Loader label="Checking subscription…" />;
  if (!subscription.has_access) return <Navigate to="/pricing" replace />;
  return children;
}

function GuestRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return null;
  if (user) return <Navigate to="/dashboard" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<GuestRoute><Login /></GuestRoute>} />
            <Route path="/register" element={<GuestRoute><Register /></GuestRoute>} />
            <Route path="/shared/:token" element={<SharedView />} />
            <Route path="/share/:token" element={<SharedDashboard />} />
            <Route path="/demo" element={<Demo />} />
            <Route path="/pricing" element={<ProtectedRoute><Pricing /></ProtectedRoute>} />
            <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
            <Route path="/payment/cancel" element={<ProtectedRoute><PaymentCancel /></ProtectedRoute>} />
            <Route path="/dashboard" element={<SubscribedRoute><Dashboard /></SubscribedRoute>} />
            <Route path="/" element={<Landing />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors theme="dark" />
      </AuthProvider>
    </div>
  );
}

export default App;
